<template>
  <div class="FINAR-Report-Main">
     <div class="left-container" :class="[ closeLeftTab ? 'left-tab-close' : '' ]" >
      <div class="arrow-button">
        <img :style="{ transform: `${closeLeftTab && !narrowWindow ? `scaleX(-1)` : (!closeLeftTab && !narrowWindow ? `scaleX(1)` : (closeLeftTab && narrowWindow ? `rotate(0deg) scaleX(-1)` : `rotate(0deg) scaleX(1)`))}` }"
          @click="closeLeftTab = !closeLeftTab" src='https://img.icons8.com/material-rounded/96/000000/double-left.png'>
      </div>
      <div class="refresh-icon" v-if="closeLeftTab">
        <Tooltip style="cursor: pointer" icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" :position="narrowWindow ? 'right' : 'bottom'"
          :iconSize="30" :yOffset="narrowWindow ? 0 : 30" :xOffset="narrowWindow ? -10 : 0" @click.native="refreshClicked">
          <div slot="tooltipText">
              <div>Report Name: <span :style="{ color: selectedReportName ? '' : 'red' }">{{ selectedReportName != null ? selectedReportName['Report'] : 'Not Selected' }}</span></div>
              <div>Date Field: <span :style="{ color: selectedDateField ? '' : 'red' }">{{ selectedDateField != null ? selectedDateField['Date Field'] : 'Not Selected' }}</span></div>
              <div>From: <span :style="{ color: selectedFromDate ? '' : 'red' }">{{ selectedFromDate ? (new Date(selectedFromDate)).formatString('yyyy-MM-dd') : 'Not Selected' }}</span></div>
              <div>To: <span :style="{ color: selectedToDate ? '' : 'red' }">{{ selectedToDate ? (new Date(selectedToDate)).formatString('yyyy-MM-dd') : 'Not Selected' }}</span></div>
              <div>Customer: <span>{{ selectedCustomerList.length == 0 ? 'All' : selectedCustomerList['Customer Code'] }}</span></div>
              <div>Charges Code: <span>{{ selectedChargeCodeList.length == 0 ? 'All' : selectedChargeCodeList['Charge Code'] }}</span></div>
          </div>
        </Tooltip>
        <!-- <img @click="refreshClicked" title="Click to Refresh" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" alt=""> -->
      </div>
      <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">

        <button @click="refreshClicked">Refresh</button>
        <div style="margin: 6px"></div>
        <Dropdown class="dropdown" :items="itemReportName" itemKey="Report" :selectedObject.sync="selectedReportName" textAlign="left" placeholder="Report Name" :isRequired="true" :errorMessage.sync="errorReportName"/>
        <div style="margin: 6px"></div>
        <Dropdown class="dropdown" :items="itemDateField" itemKey="Date Field" placeholder="Date Field" textAlign="left" :isRequired="true" :selectedObject.sync="selectedDateField" :errorMessage.sync="errorDateField"/> 
        <div style="margin: 6px"></div>
        <DateTimePicker placeholder="From" :value.sync="selectedFromDate" :showTime="false" :isDisable="false" :isRequired="true" :errorMessage.sync="fromDateError"/>
        <div style="margin: 6px"></div>
        <DateTimePicker placeholder="To" :value.sync="selectedToDate" :showTime="false" :isDisabled="false" :isRequired="true" :errorMessage.sync="toDateError"/>
        <div style="margin: 6px"></div>
        <div class="filter">
          <div class="filter-table1">
            <div class="separator"></div>
            <Filters class="gl-acc-filter" title="Customer" :tableData="customerList" itemKey="Customer Code" itemDesc="Customer Name"
              @confirmClicked="filterCustConfirm" />
            <Filters class="charge-code-filter" title="Charge Code" :tableData="chargeCodeList" itemKey="Charge Code"
              itemDesc="Description" @confirmClicked="filterChargeCodeConfirm" />
          </div>
				</div>
        <div style="margin: 6px"></div>
      </div>
    </div>
    <div class="right-container">
      <div class="generated-report-details">
        <div class="left-side">

           <div class="filtered-content">
            <div class="filtered-title">
              Report Name
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{selectedReportName != null ? selectedReportName['Report'] : ''}}
            </div>
          </div>


          <div class="filtered-content">
            <div class="filtered-title">
              Date Field
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{selectedDateField != null ? selectedDateField['Date Field'] :  ''}}
            </div>
          </div>

              <div class="filtered-content">
            <div class="filtered-title">
              From
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{injectedFromDate}}
            </div>
          </div>

              <div class="filtered-content">
            <div class="filtered-title">
               To
            </div>
            <div class="filtered-colon" >
              :
            </div>
            <div class="filtered-result">
              {{injectedToDate}}
            </div>
          </div>

        </div>
        <div class="middle-side">
          <div class="filtered-content">
            <div class="filtered-title">
              Customer Code
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{selectedCustomerList.length == 0 ? 'All' : cusCodeJoined }}
            </div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">
              Charges Code
            </div>
            <div class="filtered-colon">
              :
            </div>
            <div class="filtered-result">
              {{selectedChargeCodeList.length == 0 ? 'All' : chargeCodeJoined  }}
            </div>
          </div>
        </div>
        <div class="right-side">
          Last Refreshed : {{lastRefreshed}} 
        </div>
      </div>
      <div :style="{'height': reportContainerHeight}" class="report-container">
        <TableBox
          :title="injectedReportName"
          :tableData="tableBoxData"
          :loading="tableLoading"
          :additionalButtons="tableBoxAdditionalButtons"
          :hideColumns="columnsHide"
          :maxSelection="0"
          :dataType="tableBoxDataType"
          :tableFilters="dataFilter"
        />
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
    reportContainerHeight: function() {
      return this.showCustomMap ? "calc(50% - 41px)" : "calc(100% - 83px)";
    },
    customMapContainerHeight: function() {
      return this.showCustomMap ? "calc(50% - 41px)" : 0;
    },
    itemDateFieldFiltered: function() {
      if (!this.selectedReportName || Object.keys(this.selectedReportName).length === 0) {
        return [];
      }

      return this.itemDateField.filter((dateField) => {
        return dateField["Report Key"] === this.selectedReportName["Report Key"];
      });
    },
  },
  watch: {
    selectedReportName: function(val){
      if(val){
        this.itemDateField = this.allItemDateField ? this.allItemDateField.filter(item => item.ReportCode == this.selectedReportName.ReportCode) : null;
        this.selectedDateField = null;
        this.selectedDateField = this.itemDateField[0];
      }else{
        this.selectedDateField = null;
      }
    },
    selectedFromDate:function (val){
      this.injectedFromDate = (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');

    },
    selectedToDate:function (val){
      this.injectedToDate = (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');

    },
  },
  data: function() {
    return {
      // set true to close left tab
      closeLeftTab : false,
      // last refresh time on top right
      lastRefreshed : null,
      // data for dropdown
      itemReportName  : [],
      selectedReportName : null,
      injectedReportName : 'Report',
      errorReportName : '',
      itemDateField : [],
      allItemDateField : [],
      selectedDateField : null,
      customerList : [],
      selectedCustomerList : [],
      chargeCodeList : [],
      selectedChargeCodeList : [],
      injectedDateField : '',
      errorDateField : '',
      // data for datetimepicker components
      selectedFromDate : null,
      injectedFromDate : '',
      fromDateError : '',
      selectedToDate : null,
      injectedToDate : '',
      toDateError : '',
      dataFilter: null,
      tableBoxData : [],
      tableBoxDataType : {},
      tableLoading : false,
      columnsHide : [],
      columnsNumber : {},
      tableBoxAdditionalButtons: [],

      showCustomMap: false,

      narrowWindow: false,
      showAttachmentWindow : false,
      attachmentList: [],
      imageExist: false,
      image:'',
      currentAttachmentIndex : 0,
      selectedData: [],

      cusCodeJoined: '',
      chargeCodeJoined: '',
      module: '',

    }
  },
  props: {
  },
  methods: {
		filterChargeCodeConfirm: function (items) {
			this.selectedChargeCodeList = items;
      let chargesCodes = this.selectedChargeCodeList.map(obj => obj["Charge Code"]);
      this.chargeCodeJoined = chargesCodes.join(",");
		},
		filterCustConfirm: function (items) {
			this.selectedCustomerList = items;
      let customerCodes = this.selectedCustomerList.map(obj => obj["Customer Code"]);
      this.cusCodeJoined = customerCodes.join(",");
		},
    errorReportNameCheck : function() {
      if (!this.selectedReportName) {
        this.errorReportName = 'Please choose one input Report Name';
        return true;
      }
      return false;
    },
    errorDateFieldCheck : function() { 
      if (!this.selectedDateField) {
        this.errorDateField = 'Please choose one input date';
        return true;
      }
      return false;
    },
    errorDatePickerCheck : function() {
      if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
        this.fromDateError = 'From Date cannot later than To Date';
        this.toDateError = 'From Date cannot later than To Date';
        return true;
      }
      return false;
    },
    refreshClicked : async function() {
      this.$fullscreenLoading('Refreshing');
      this.tableBoxData = [];
      this.tableBoxDataType = {};
      this.fromDateError = '';
      this.toDateError = '';
      this.errorDateField = '';
      this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');
      this.injectedFromDate = (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');
      this.injectedToDate = (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');

      // check the filters whether is correctly selected / blank check
      if (this.errorReportNameCheck() || this.errorDateFieldCheck()){
        this.$fullscreenLoading();
        this.$showAlert('error', 'Filters are incomplete');
        return;
      }
      if (this.errorDatePickerCheck()){
        this.$fullscreenLoading();
        this.$showAlert('error', 'Invalid Date selection');
        return;
      }
      this.injectedDateField = this.selectedDateField['Date Field'];
      this.injectedReportName = this.selectedReportName['Report'];

      this.tableLoading = true;
      let dataToPost = {
        startdate: (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd'),
        enddate: (new Date(this.selectedToDate)).formatString('yyyy-MM-dd'),
        reportcode: this.selectedReportName['ReportCode'],
        datetype: this.selectedDateField['Date Field'],
        customerarray: this.selectedCustomerList.length == 0 ? "" : this.cusCodeJoined,
        chargecodearray: this.selectedChargeCodeList.length == 0 ? "" : this.chargeCodeJoined,
      }
      let apiRet = await this.$apiCallV2(`/FINARReport/FINARReport`, dataToPost);
      this.$fullscreenLoading();
      if (apiRet.length == 0) {
        this.tableLoading = false;

        return;
      }

      if (apiRet[0]["Results"] == 1) { // if API returned an error
        this.tableLoading = false;
        this.$showAlert("error", "An error occurred", apiRet[0]["ErrMsg"]);

        return;
      }else{        
        this.injectedReportName = this.selectedReportName['Report'];
        this.tableBoxData = [];
        this.$nextTick(() => {
          this.tableBoxData = apiRet;          
          this.tableBoxDataType = this.selectedReportName['ReportCode'] == 'SALESANALYSIS_BY_INV_CHARGECODE' ? apiRet[0] : {
            'Amount' : 'currency',
            'Tax Amount' : 'currency',
            'Amount Incl Tax' : 'currency',
            'Qty' : 'number',
          }
          let newDataFilter = {}; 
          newDataFilter['Report Name' ] = this.selectedReportName['ReportCode'];
          newDataFilter['Date Field' ] = this.selectedDateField['Date Field'];
          newDataFilter['From' ] =   (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');
          newDataFilter['To' ] =   (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');
          newDataFilter['Customer Code' ] = this.selectedCustomerList.length == 0 ? "All" : this.cusCodeJoined;
          newDataFilter['Charges Code' ] = this.selectedChargeCodeList.length == 0 ? "All" : this.chargeCodeJoined;
          this.dataFilter = newDataFilter;
        })
      }

      this.tableLoading = false;
    },
    windowResize: function() {
      this.narrowWindow = window.innerWidth < 900;
    },
  },
  async mounted() {
    this.narrowWindow = window.innerWidth < 900;
    this.$fullscreenLoading('Mounting in');
    let query = this.$route.path;
    const parts = query.split('/');
    this.module = parts[3];
    this.closeLeftTab = false;
    // default refresh datetime on mounted
    this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

    // default from Date and to Date to beginning of the month to end of the month
    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0); 

    this.$fullscreenLoading('Getting Report Type...');
    this.itemReportName = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'RPT_REPORT', module: this.module});
    this.selectedReportName =  this.itemReportName ? this.itemReportName[0] : null;

    this.$fullscreenLoading('Getting Date Field...');
    this.allItemDateField = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'RPT_REPORT_DATEFIELD', module: this.module});
    this.itemDateField = this.allItemDateField ? this.allItemDateField.filter(item => item.ReportCode == this.selectedReportName.ReportCode) : null;
    this.selectedDateField = this.itemDateField[0];

    this.$fullscreenLoading('Getting Customer...');
    this.customerList = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'BILLCUST'});
  
    this.$fullscreenLoading('Getting Charge Code...');
    this.chargeCodeList = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'CHARGESCODE', module: this.module});
    
    this.injectedFromDate = (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');
    
    this.injectedToDate = (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');

    this.$fullscreenLoading();

    window.addEventListener('resize', this.windowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize);
  },

}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.FINAR-Report-Main{
  font-size: 12px;
  width: 200px;
  height :100%;
  padding : 10px 45px;
  display: flex;
  overflow: hidden;

  > .left-container{
    z-index: 111;
    border-radius : 5px;
    max-width: 200px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;

    > .arrow-button{
      width: 100%;
      padding : 7px 4px 50px 0px;
      display: flex;
      justify-content: flex-end;

      > img{
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transform: scale(1);
        transition: 0.3s;
        cursor: pointer;

        // same as > img :hover {}
        &:hover { 
          border-radius: 50%;
          background-color: rgba(0,0,0,0.5) ;
          transition: 0.3s ease;
        }
      }
    }

    > .refresh-icon{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top : 5px;
      cursor: pointer;
    }

    > .left-container-content{
      background-color: white;
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      padding-left: 5px;

      > button{
        width: 90%;
        margin-left: 5px;
      }

      > .dropdown{
        width: 95%;
      }
      > .filter{
        position: relative;
        width: 100%;
        height: 100%;
        flex-wrap: wrap;

        .filter-table1 {
          height: calc(100% - 500px);
          min-height: 200px;
          display: flex;

          >.gl-acc-filter>.charge-code-filter {
            height: 100%;
          }
        }
      }
    }
  }

  > .left-tab-close {
    z-index: 111;
    max-width: 40px;
  }

  > .right-container{
    border-radius : 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .generated-report-details {
      width: 100%;
      border-radius: 5px;
      background-color : white;
      margin-bottom: 5px;
      display: flex;

      > .left-side{
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-bottom: 3px;
        // justify-content: space-around;
        flex: 1;

        > .filtered-content{
          display: flex;

          > .filtered-title{
            min-width: 100px;
            max-width: 100px
          }

          > .filtered-colon{
            padding-left: 5px;
            padding-right: 5px;  
          }

          > .filtered-result{

            text-overflow: ellipsis;
          }
        }
      }

      > .middle-side{
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-bottom: 3px;
        // justify-content: space-around;
        flex: 0.7;

        > .filtered-content{
          display: flex;
          overflow: auto;

          > .filtered-title{
            min-width: 100px;
            max-width: 100px
          }

          > .filtered-colon{
            padding-left: 5px;
            padding-right: 5px;  
          }
          > .filtered-result{
            text-overflow: ellipsis;
          }
        }
      }
      > .right-side{
        padding-right: 5px;
        height: 100%;
      }
    
    }

    > .report-container{
      width: 100%;
      margin-bottom: 5px;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      display: flex;
    }

    > .custom-map-container {
      width: 100%;
      background-color: white;
      border-radius: 5px;
      padding: 0 5px 13px 5px;

      > .close-button-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > .close-button {
          height: 25px;
          width: 25px;
          cursor: pointer;
        }
      }

      > .custom-map-component {
        height: calc(100% - 25px); // 100% minus height of close-button
      }
    }
  }
}
</style>